/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EmailSignatureResponse } from './emailSignatureResponse';
import type { LinkedInAccountResponse } from './linkedInAccountResponse';
import type { LinkedInSignatureResponse } from './linkedInSignatureResponse';
import type { MailboxResponse } from './mailboxResponse';

export interface ConnectedAccountsSummary {
  mailboxes?: MailboxResponse[];
  linkedin_account?: LinkedInAccountResponse | null;
  email_signatures?: EmailSignatureResponse[];
  linkedin_signatures?: LinkedInSignatureResponse[];
  mailbox_limit?: number | null;
  linkedin_limit?: number | null;
}
